<template>
    <div class="h-max w-max">
        <div class="is-clearfix">
            <img class="is-pulled-left image p-sm" src="static/dimoco/778mobile_logo.svg" style="height:4rem;">
            <img v-if="false" class="is-pulled-right image p-sm" src="static/dimoco/dimoco_carrier_billing.jpg" style="height:4rem;">
        </div>
        <div class="p-sm m-t-md">
            <p class="is-size-6 ff-rb p-b-sm">
                778 mobile GmbH<br>
                Aktywuj dostęp do:<br>Keep YOU fit.<br>za 11,50 zł<br>Opłata będzie pobierana 1x co tydzień.
            </p>
            <p class="is-size-7 ff-rl p-b-sm">
                Aby dokonać rezygnacji należy wysłać SMS o treści STOP KYF na 80460 (T-Mobile) (koszt: 0 zł). 
                Opłata zostanie doliczona do Twojego rachunku w u twojego operatora (telefon na abonament) lub odliczona od środków na koncie (telefon na kartę).
            </p>
            <p class="is-size-6 ff-rb">
                Wprowadź swój numer telefonu:
            </p>
            <p class="is-size-7 ff-rl">
                Przygotuj telefon, za chwilę otrzymasz wiadomość z kodem PIN, którym zatwierdzisz zamówienie.
            </p>
        </div>
        <div class="p-sm ff-rb columns is-mobile">
            <div class="column is-8">
                <input type="phone" @change="setValid" :class="'input msisdn-input is-link ' + validClass" v-model="msisdn" placeholder="Twój numer telefonu" /> 
                <p class="is-size-7 ff-rl p-t-sm">
                    Wypełnienie tego formularza oznacza akceptacje <router-link class="has-text-link ff-rl" :to="{ name: 'Terms' }">Regulaminu Usługi</router-link>
                </p>
            </div>
            <div class="column">
                <input type="submit" @click="send" class="button is-fullwidth is-link" value="Dalej" />
            </div>
        </div>
        <div class="m-sm columns is-mobile dimoco-logos has-text-centered">
            <div class="column is-3">
                <img class="image" src="static/dimoco/PL_orange_msisdn.png">
            </div>
            <div class="column is-3">
                <img class="image" src="static/dimoco/PL_play_msisdn.png">
            </div>
            <div class="column is-3">
                <img class="image" src="static/dimoco/PL_tm_msisdn.png">
            </div>
            <div class="column is-3">
                <img class="image" src="static/dimoco/PL_plus_msisdn.png">
            </div>
        </div>
    </div>
</template>

<script>
export default {
  name: 'MsisdnEntry',
  data () {
      return {
        msisdn: this.$route.query.msisdn || '',
        default: true,
        requestId: this.$route.query.requestId
      }
  },
  computed: {
      valid() {
          return this.default && this.msisdn.match(/^\+?[0-9\s]*$/) !== null
      },
      validClass() {
          return this.valid ? 'valid' : 'invalid'
      }
  },
  methods: {
      send() {
          const arr = this.msisdn.replace(' ', '').match(/^(\+48|0048|048|0)?([1-9][0-9]{8})$/)
          if (arr !== null) {
              document.location.replace(`/dimoco/mi/pl/0048${ arr[2] }?requestId=${ this.requestId }`)
          } else {
            this.default = false
          }
      },
      setValid() {
          this.default = true
      }
  }
}
</script>
<style>
.msisdn-input {
    border-radius: 4px;
    border-width: 2px;
}
.msisdn-input:hover, .msisdn-input:focus {
    border-radius: 4px;
    border-width: 2px;
    -webkit-box-shadow: 0px 0px 10px 5px rgba(200,200,200,0.5);
    -moz-box-shadow: 0px 0px 10px 5px rgba(200,200,200,0.5);
    box-shadow: 0px 0px 10px 5px rgba(200,200,200,0.5);
}
.dimoco-logos {
    background-image: linear-gradient(90deg, #ff6600 19%,#59398a 29%,#e2007a 70%,#66b03b 80%);
    height: 3px;
}
.dimoco-logos .image {
    display: inline-block;
    max-height: 4rem;
}
input.invalid, input.invalid:hover, input.invalid:focus {
    border-color: red !important;
}
</style>





// WEBPACK FOOTER //
// src/components/LangKyf/PL/MsisdnEntry.vue